export enum OfflineDocumentType {
  ApplicationForm = '01',
  ConsentLetter = '02',
  IncomeDocumentPaysip = '03',
  GuarantorICAndIncomeDocuments = '04',
  IdentityCardFront = '05',
  StudentCardFrontAndBack = '06',
  Others = '07',
  IdentityCardBack = '08'
}